module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_iter-step.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_iter-step.js
// module chunks = 2